import raw from './tokens.json';

/** The customer-side design tokens (see tokens.json). */
export type Tone = keyof typeof raw.tones;
export type StatusKey = keyof typeof raw.status;

export const tokens = raw;
export const tone = (t: Tone) => raw.tones[t];

/**
 * The step a canteen order is at, from any status the server sends (PENDING, ACCEPTED,
 * PREPARING, COOKING, READY, DELIVERED, COLLECTED, CANCELLED...). Unknown reads as placed.
 */
export function statusOf(orderStatus: string | null | undefined): StatusKey {
  const s = (orderStatus ?? '').trim().toUpperCase();
  if (s === 'CANCELLED' || s === 'REJECTED') return 'cancelled';
  if (s === 'DELIVERED' || s === 'COLLECTED' || s === 'COMPLETED') return 'collected';
  if (s === 'READY') return 'ready';
  if (s === 'PREPARING' || s === 'COOKING' || s === 'IN_PROGRESS' || s === 'ACCEPTED') return 'preparing';
  return 'placed';
}

/** 0-based position on the Placed -> Preparing -> Ready -> Collected track. */
export const stepIndex = (status: StatusKey): number =>
  ({ placed: 0, preparing: 1, ready: 2, collected: 3, cancelled: -1 } as const)[status];

/** Money in the school's currency, always with cents: it is a balance or a price. */
export function money(n: number | null | undefined, currency = 'USD'): string {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency}`;
  }
}
